import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { Table, Button, Modal } from 'antd';
import API from "../../Services/BaseService";
import Loading from "../../Component/Loading/Loading";
import { useSelector } from 'react-redux';
import ErrorPopup from "../FallBackUI/ErrorPopup";
import moment from 'moment';

const URpostCarById = ({ carId }) => {
    console.log("r======", carId)
    const history = useHistory();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [urPostCar, setUrPostCar] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const sellerData = useSelector(state => state.LoginReducer.payload);
    console.log("Seller Data Checking", sellerData)
    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    const columns = [

        {
            title: 'Car #',
            dataIndex: 'car_id',

        },

        {
            title: 'Make',
            dataIndex: 'make',

        },

        {
            title: 'Model',
            dataIndex: 'model',

        },
        {
            title: 'Vin #',
            dataIndex: 'vin_no',

        },
        {
            title: 'Year',
            dataIndex: 'year',
            render: (text) => text === 0 ? "" : text
        },
        // {
        //     title: 'Sales Type',
        //     dataIndex : 'sales_type_id == 1' ? "buyitnow" : "sealedbid",

        // },

        {
            title: 'Sales Type',
            dataIndex: 'sales_type_id',
            key: 'sales_type_id',
            render: (text) => text === 1 ? 'Sealed Bid' : text === 2 ? 'Buy It Now' : text === 3 ? 'Auction' : ""
            // render: (text, record) => {
            //   const dataIndex = record.sales_type_id == 1 ? 'activeStatus' : 'inactiveStatus';
            //   return <span>{record[dataIndex]}</span>;
            // },
        },

    ];

    async function fetchURPostCar() {
        console.log("inside fn");
        let request = {
            seller_info_id: carId,
            seller_id: sellerData.seller_id,
            seller_token: sellerData.seller_token,

        };
        const state = API.post('urpostCarbyid/condition', request);
        state.then(res => {
            console.log("res", res)
            if (res.data.success === true) {
                setUrPostCar(res.data.data);
                setLoading(false);
            }
            else {
                setErrors(res.data.error.name)
                setErrorFlag(true)
            }
        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
                setLoading(false);
            }
        });
    }
    useEffect(() => {
        console.log("URPOST CAR")
        fetchURPostCar();
    }, [carId]);
    function formatTime(value) {
        if (value == null || value == undefined || value == "null" || value == "undefined") {
            return value
        }
        else {
            let local = new Date(value);
            let offset = local.getTimezoneOffset();
            value = new Date(local.getTime() - offset * 60000);
            value = moment(value).format('MMMM D, YYYY hh:mm A');
            return value;
        }
    }
    return (
        <div>
            {errorFlag === true ? <ErrorPopup error={errors} /> :
                <div className="feesblock viewurpostpopup col-lg-12">
                    <div className="section-title">
                        <h2>URpost details
                            {/* <span>
                        <Button className="ant-btn" onClick={() => history.push("/urpost")}><i className="icofont-plus"></i> Add</Button></span> */}
                        </h2>

                    </div>
                    <div class="table-box">
                        <div class="table-responsive">
                            <div class="">

                                {loading ? <Loading /> :
                                    <div class="sellerChargesListtable table-responsive">
                                        <div className="abletable">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        {/* <th className="">Charges #</th> */}
                                                        <th className="">Car #</th>
                                                        <th className="">Make</th>
                                                        <th className="">Model</th>
                                                        <th className="">Vin #</th>
                                                        <th className="">Year</th>
                                                        <th className="">Sales Type</th>
                                                        <th className="">Date & Time</th>

                                                    </tr>
                                                </thead>

                                                {/* {sellerChargeList.length > 0 ? sellerChargeList.map((item) => */}
                                                {urPostCar.length > 0 ? urPostCar.map((item) =>

                                                    <tr>
                                                        <td>{item.car_id}</td>
                                                        <td>{item.make}</td>
                                                        <td>{item.model}</td>
                                                        <td>{item.vin_no}</td>
                                                        <td>{item.year == 0 ||item.year == "0" ||item.year == null ? "" :item.year}</td>
                                                        <td>{item.sales_type_id === 1 ? 'Sealed Bid' : item.sales_type_id === 2 ? 'Buy It Now' : item.sales_type_id === 3 ? 'Auction' : ""}</td>
                                                        <td>{formatTime(item.date_tz)}</td>

                                                    </tr>
                                                ) :
                                                    <tr>
                                                        <td colspan="13" ng-show="0"><b>There's No Data</b></td>
                                                    </tr>
                                                }

                                            </table>
                                        </div>
                                    </div>}

                            </div>
                        </div>
                    </div>
                </div>





            }


        </div>
    );
};

export default URpostCarById;